import "./App.css";
import { Routes, Route } from "react-router-dom";
import "@fontsource/poppins";

// Shared Components
import Navbar from "./components/shared/Navbar/Navbar";
import Footer from "./components/shared/Footer";
import NotFound from "./components/shared/NotFound";
import ScrollToTop from "./components/hooks/ScrollToTop";
import MovingText from "./components/Home/MovingText";

// Pages
import Home from "./components/Home/Home";
import Admission from "./components/Admission/Admission";
import Faculty from "./components/Faculty/Faculty";
import AboutUs from "./components/AboutUs/AboutUs";
import Contact from "./components/Contact/Contact";
import Tution from "./components/Tution/Tution";
import SingleNotice from "./components/SingleNotice/SingleNoticee";
import SingleNoticee2 from "./components/SingleNotice/SingleNoticee2";
import GovernImg from "./components/GovernImg/Governing_body";
import Departments from "./components/Home/Departments";
import NewsNoticeDetails from "./components/shared/NewsNoticeDetails";

// Administration
import Message from "./components/Administration/Message";
import TeachersData from "./components/Administration/TeachersData";
import TeachersDetail from "./components/Administration/TeachersDetail"; // ✅ CORRECT NAME

// Facilities
import ModernLab from "./components/Facilities/ModernLab";
import ClubOrganization from "./components/Facilities/ClubOrganization";
import ClubDetails from "./components/Facilities/ClubDetails";
import Library from "./components/Facilities/Library";

// Student Corner
import StudentCorner from "./components/StudentCorner/StudentCorner";
import Result from "./components/StudentCorner/Result";
import ExamNotice from "./components/StudentCorner/ExamNotice";
import ExamRoutine from "./components/StudentCorner/ExamRoutine";

function App() {
  return (
    <div className="font-poppins">
      <MovingText />
      <Navbar />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/article/:person" element={<Message />} />

        {/* ✅ Teacher Details Page */}
        <Route path="/teacher/:id" element={<TeachersDetail />} />

        {/* Teachers By Department */}
        <Route path="/teachers/:dept" element={<TeachersData />} />

        <Route path="/faculty/:dept" element={<Faculty />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-info" element={<Contact />} />
        <Route path="/govern-body" element={<GovernImg />} />
        <Route path="/tution" element={<Tution />} />
        <Route path="/single-notice" element={<SingleNotice />} />
        <Route path="/single-notice2" element={<SingleNoticee2 />} />

        {/* Student Corner */}
        <Route path="/student-corner" element={<StudentCorner />}>
          <Route index element={<Result />} />
          <Route path="result" element={<Result />} />
          <Route path="exam-notice" element={<ExamNotice />} />
          <Route path="exam-routine" element={<ExamRoutine />} />
        </Route>

        <Route path="/programs" element={<Departments />} />
        <Route path="/details/:catagory/:id" element={<NewsNoticeDetails />} />
        <Route path="/modern-lab" element={<ModernLab />} />
        <Route path="/club-organization" element={<ClubOrganization />} />
        <Route path="/club-organization/:clubName" element={<ClubDetails />} />
        <Route path="/library" element={<Library />} />

        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
